import React from 'react';
import { Link } from 'react-router-dom';
import logoCentre from '../../assets/images/logoCentre.PNG';
import Procedure from '../landing/components/procedure';
import Footer from '../footer';

export default function ReservationSalle() {
  return (
    <div className='w-full flex flex-col items-center'>
      <div className='w-full 3xl:w-[1200px] flex justify-center'>
        <Link to='/reservation'>
          <img src={logoCentre} alt='logo center' className='w-[200px]'/>
        </Link>
      </div>
      <div className='flex justify-center w-full bg-primary'>
        <div className='w-full bg-primary flex justify-between items-center px-10 3xl:px-0 3xl:w-[1200px]'>
          <p className='text-white font-inter font-semiBold text-lg'>Portail de résérvation de salle</p>
          <p className='hidden sm:inline text-white font-inter font-semiBold text-lg text-end'>Room booking portal</p>
          <p className='sm:hidden text-white font-inter font-semiBold text-lg text-end'>M.T.C</p>
        </div>
      </div>
      <div className='mt-10'>
        <p className='text-primary text-center text-2xl xxs:text-3xl font-medium mb-10'>Bienvenu dans le portail de réservation de salle</p>
        <Procedure />
      </div>
      <div className='w-full'>
        <Footer />
      </div>
    </div>
  );
}
